module.exports = __webpack_public_path__ + "img/video_invite_member.d7a70ac4.svg";